/**
 * Constantes para tipos MIME comunes.
 * Usa estas constantes para especificar el tipo de archivo (ej. PDF, Excel).
 */

export const FILE_TYPE = {
  PDF: 'application/pdf',
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}